import React, { useState } from "react";
import { useDownloadAssets } from "../../context/DownloadAssetsContext";
const styles = {
  container: {
    position: "fixed",
    bottom: 20,
    right: 20,
    width: 320,
    background: "#fff",
    border: "1px solid #3b82f6",
    borderRadius: 10,
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    fontFamily: "Inter, sans-serif",
    zIndex: 9999,
  },

  header: {
    padding: "10px 14px",
    borderBottom: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 500,
  },

  headerActions: {
    display: "flex",
    gap: 6,
  },

  iconBtn: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 16,
  },

  body: {
    padding: 10,
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 0",
    gap: 8,
  },

  fileIcon: {
    fontSize: 16,
  },

  text: {
    flex: 1,
    fontSize: 14,
  },

  spinner: {
    width: 16,
    height: 16,
    border: "2px solid #e5e7eb",
    borderTop: "2px solid #3b82f6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },

  done: {
    color: "#16a34a",
    fontWeight: "bold",
  },

  failed: {
    color: "#dc2626",
    fontWeight: "bold",
  },
};

export default function DownloadQueuePanel() {
  const { downloadingAssets, removeDownload } = useDownloadAssets();
  const [collapsed, setCollapsed] = useState(false);

  if (!downloadingAssets.length) return null;

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <span>Preparing download</span>
        <div style={styles.headerActions}>
          <button onClick={() => setCollapsed(!collapsed)} style={styles.iconBtn}>
            {collapsed ? "▴" : "▾"}
          </button>
          <button
            onClick={() =>
              downloadingAssets.forEach((d) => removeDownload(d.id))
            }
            style={styles.iconBtn}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Body */}
      {!collapsed && (
        <div style={styles.body}>
          {downloadingAssets.map((item) => (
            <div key={item.id} style={styles.row}>
              <span style={styles.fileIcon}>📄</span>

              <span style={styles.text}>
                {item.status === "PROCESSING" && "Processing"}
                {item.status === "ZIPPING" && "Zipping"}
                {item.status === "PENDING" && "Preparing"}
                {item.status === "DONE" && "Completed"}
                {item.status === "FAILED" && "Failed"}
              </span>

              <span>
                {item.status === "DONE" ? (
                  <span style={styles.done}>✔</span>
                ) : item.status === "FAILED" ? (
                  <span style={styles.failed}>✕</span>
                ) : (
                  <span style={styles.spinner} />
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
